
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aircraft-types/[uid]",
      function () {
        return require("private-next-pages/aircraft-types/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aircraft-types/[uid]"])
      });
    }
  